import { useNavigate } from 'react-router-dom';
import { 
  Calendar, 
  Users, 
  Scale, 
  Heart, 
  DollarSign,
  Cat
} from 'lucide-react';

interface QuickAction {
  id: string;
  name: string;
  icon: React.ReactNode;
  path: string;
}

export function QuickActionsWidget() {
  const navigate = useNavigate();

  const quickActions: QuickAction[] = [
    { 
      id: 'calendar', 
      name: 'Calendar', 
      icon: <Calendar className="h-5 w-5" />, 
      path: '/dashboard/calendar'
    },
    { 
      id: 'trusted-advisors', 
      name: 'Trusted Advisors', 
      icon: <Users className="h-5 w-5" />, 
      path: '/dashboard/trusted-advisors'
    },
    { 
      id: 'legal', 
      name: 'Legal', 
      icon: <Scale className="h-5 w-5" />, 
      path: '/dashboard/legal'
    },
    { 
      id: 'health', 
      name: 'Health', 
      icon: <Heart className="h-5 w-5" />, 
      path: '/dashboard/health'
    },
    { 
      id: 'financial', 
      name: 'Financial', 
      icon: <DollarSign className="h-5 w-5" />, 
      path: '/dashboard/financial'
    },
    { 
      id: 'pets', 
      name: 'Pets', 
      icon: <Cat className="h-5 w-5" />, 
      path: '/dashboard/pets'
    }
  ];

  return (
    <div className="bg-white rounded-lg shadow p-4">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-gray-900">Quick Actions</h3>
      </div>

      <div className="grid grid-cols-3 gap-4">
        {quickActions.map(action => (
          <div key={action.id} className="flex flex-col items-center">
            <button
              onClick={() => navigate(action.path)}
              className="w-12 h-12 rounded-full bg-idecide-primary text-white flex items-center justify-center transition-all duration-200 hover:scale-105 hover:shadow-md hover:bg-idecide-secondary"
              title={action.name}
            >
              {action.icon}
            </button>
            <span className="text-xs text-gray-600 mt-2 text-center font-medium">
              {action.name}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}